import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@/primitives';

export interface DiscardDialogProps {
  open: boolean;
  onClose: () => void;
  onDiscard: () => void;
  title: string;
  content: string;
  cancelText: string;
  discardText: string;
}

export function DiscardDialog({
  open,
  onClose,
  onDiscard,
  title,
  content,
  cancelText,
  discardText,
}: DiscardDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {cancelText}
        </Button>
        <Button onClick={onDiscard} color="primary" autoFocus>
          {discardText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
